import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'

import url from './assets/js/api'
import axios from './assets/js/axios'
import './assets/js/flexible.min.js'

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.url = url
Vue.use(Vant)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
